/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { css } from '@emotion/react';
import {
  SubscriptionForm,
  Props as SubscriptionFormProps,
} from './SubscriptionForm';
import { DisclaimerText } from './DisclaimerText';
import { TypographyName } from '../../../theme';

const Styles = {
  ctaContainer: css`
    text-align: center;
    display: flex;
    align-items: stretch;
    flex-direction: column;
    text-align: left;
  `,
};
type SubscriptionFormWithDisclaimerProps = SubscriptionFormProps & {
  disclaimerTextColor?: 'primary' | 'secondary';
  disclaimerTextType?: TypographyName;
};

/**
 * Internal component for using the Subscription Form in the Page builder
 * along with some disclaimer
 */
export const SubscriptionFormWithDisclaimer = ({
  disclaimerTextColor = 'primary',
  disclaimerTextType,
  ...restProps
}: SubscriptionFormWithDisclaimerProps) => {
  return (
    <div css={Styles.ctaContainer}>
      <SubscriptionForm {...restProps} fluidInput={true} />
      <DisclaimerText
        color={disclaimerTextColor}
        textType={disclaimerTextType}
      />
    </div>
  );
};
